import { Action } from '@ngrx/store';

import { BaseListReqParams } from 'modules/shared/models/base.models';
import {
  EditOwnRestrictedNamePayload, AddOwnRestrictedNameRequest, GetOwnRestrictedListRequest,
  OwnRestrictedListRequest, EditOwnRestrictedListPayload, GetOwnRestrictedNamesRequest
} from 'store/models/own-restricted-list.models';

export enum OwnRestrictedListActionTypes {
  GET_OWN_RESTRICTED_LIST = 'GET_OWN_RESTRICTED_LIST',
  GET_OWN_RESTRICTED_LIST_SUCCESS = 'GET_OWN_RESTRICTED_LIST_SUCCESS',
  GET_OWN_RESTRICTED_LIST_FAILURE = 'GET_OWN_RESTRICTED_LIST_FAILURE',
  GET_OWN_RESTRICTED_LISTS = 'GET_OWN_RESTRICTED_LISTS',
  GET_OWN_RESTRICTED_LISTS_SUCCESS = 'GET_OWN_RESTRICTED_LISTS_SUCCESS',
  GET_OWN_RESTRICTED_LISTS_FAILURE = 'GET_OWN_RESTRICTED_LISTS_FAILURE',
  CREATE_OWN_RESTRICTED_LIST = 'CREATE_OWN_RESTRICTED_LIST',
  CREATE_OWN_RESTRICTED_LIST_SUCCESS = 'CREATE_OWN_RESTRICTED_LIST_SUCCESS',
  CREATE_OWN_RESTRICTED_LIST_FAILURE = 'CREATE_OWN_RESTRICTED_LIST_FAILURE',
  UPDATE_OWN_RESTRICTED_LIST = 'UPDATE_OWN_RESTRICTED_LIST',
  UPDATE_OWN_RESTRICTED_LIST_SUCCESS = 'UPDATE_OWN_RESTRICTED_LIST_SUCCESS',
  UPDATE_OWN_RESTRICTED_LIST_FAILURE = 'UPDATE_OWN_RESTRICTED_LIST_FAILURE',
  GET_RESTRICTED_NAMES = 'GET_RESTRICTED_NAMES',
  GET_RESTRICTED_NAMES_SUCCESS = 'GET_RESTRICTED_NAMES_SUCCESS',
  GET_RESTRICTED_NAMES_FAILURE = 'GET_RESTRICTED_NAMES_FAILURE',
  CREATE_RESTRICTED_NAME = 'CREATE_RESTRICTED_NAME',
  CREATE_RESTRICTED_NAME_SUCCESS = 'CREATE_RESTRICTED_NAME_SUCCESS',
  CREATE_RESTRICTED_NAME_FAILURE = 'CREATE_RESTRICTED_NAME_FAILURE',
  EDIT_RESTRICTED_NAME = 'DELETE_RESTRICTED_NAME',
  EDIT_RESTRICTED_NAME_SUCCESS = 'DELETE_RESTRICTED_NAME_SUCCESS',
  EDIT_RESTRICTED_NAME_FAILURE = 'DELETE_RESTRICTED_NAME_FAILURE',
  RESET_RESTRICTED_STATE = 'RESET_RESTRICTED_STATE',
}

export class GetOwnRestrictedList implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LIST;
  constructor(public payload: GetOwnRestrictedListRequest = null) { }
}

export class GetOwnRestrictedListSuccess implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LIST_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetOwnRestrictedListFailure implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LIST_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetOwnRestrictedLists implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LISTS;
  constructor(public payload?: BaseListReqParams) { }
}

export class GetOwnRestrictedListsSuccess implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LISTS_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetOwnRestrictedListsFailure implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LISTS_FAILURE;
  constructor(public payload: any = null) { }
}

export class CreateOwnRestrictedList implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.CREATE_OWN_RESTRICTED_LIST;
  constructor(public payload: OwnRestrictedListRequest = null) { }
}

export class CreateOwnRestrictedListSuccess implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.CREATE_OWN_RESTRICTED_LIST_SUCCESS;
  constructor(public payload: any = null) { }
}

export class CreateOwnRestrictedListFailure implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.CREATE_OWN_RESTRICTED_LIST_FAILURE;
  constructor(public payload: any = null) { }
}

export class UpdateOwnRestrictedList implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.UPDATE_OWN_RESTRICTED_LIST;
  constructor(public payload: EditOwnRestrictedListPayload = null) { }
}

export class UpdateOwnRestrictedListSuccess implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.UPDATE_OWN_RESTRICTED_LIST_SUCCESS;
  constructor(public payload: any = null) { }
}

export class UpdateOwnRestrictedListFailure implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.UPDATE_OWN_RESTRICTED_LIST_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetRestrictedNames implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.GET_RESTRICTED_NAMES;
  constructor(public payload: GetOwnRestrictedNamesRequest = null) { }
}

export class GetRestrictedNamesSuccess implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.GET_RESTRICTED_NAMES_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetRestrictedNamesFailure implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.GET_RESTRICTED_NAMES_FAILURE;
  constructor(public payload: any = null) { }
}

export class CreateRestrictedName implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.CREATE_RESTRICTED_NAME;
  constructor(public payload: AddOwnRestrictedNameRequest = null) { }
}

export class CreateRestrictedNameSuccess implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.CREATE_RESTRICTED_NAME_SUCCESS;
  constructor(public payload: any = null) { }
}

export class CreateRestrictedNameFailure implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.CREATE_RESTRICTED_NAME_FAILURE;
  constructor(public payload: any = null) { }
}

export class EditRestrictedName implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.EDIT_RESTRICTED_NAME;
  constructor(public payload: EditOwnRestrictedNamePayload = null) { }
}

export class EditRestrictedNameSuccess implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.EDIT_RESTRICTED_NAME_SUCCESS;
  constructor(public payload: any = null) { }
}

export class EditRestrictedNameFailure implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.EDIT_RESTRICTED_NAME_FAILURE;
  constructor(public payload: any = null) { }
}

export class ResetRestrictedState implements Action {
  readonly type: OwnRestrictedListActionTypes = OwnRestrictedListActionTypes.RESET_RESTRICTED_STATE;
  constructor(public payload: any = null) { }
}

export type OwnRestrictedListActions =
  | GetOwnRestrictedList
  | GetOwnRestrictedListSuccess
  | GetOwnRestrictedListFailure
  | GetOwnRestrictedLists
  | GetOwnRestrictedListsSuccess
  | GetOwnRestrictedListsFailure
  | CreateOwnRestrictedList
  | CreateOwnRestrictedListSuccess
  | CreateOwnRestrictedListFailure
  | UpdateOwnRestrictedList
  | UpdateOwnRestrictedListSuccess
  | UpdateOwnRestrictedListFailure
  | GetRestrictedNames
  | GetRestrictedNamesSuccess
  | GetRestrictedNamesFailure
  | CreateRestrictedName
  | CreateRestrictedNameSuccess
  | CreateRestrictedNameFailure
  | EditRestrictedName
  | EditRestrictedNameSuccess
  | EditRestrictedNameFailure
  | ResetRestrictedState
  ;
